module.exports = __webpack_public_path__ + "img/chargedetailsLogo.81fa7900.png";